<div class="p-5 mb-5">
  <div class="efile-page">
    <h1 style="color: black">Let's get your signature</h1>
    <ng-container *ngIf="errorMessage">
      <p style="color: red">An invalid document id has been supplied. Please check the link and try again.</p>
    </ng-container>
    <ng-container *ngIf="!errorMessage">
      <iframe *ngIf="!formHelper.isMobileDevice() && !formHelper.isSafari()" style="overflow:hidden; height:100vh; width:100%; border: none" height="100%" width="100%" [src]="accessLink | SafeUrl"></iframe>
      <alert *ngIf="formHelper.isMobileDevice()" type="info">
        <p class="m-3">If the pop up is blocked, please click to <a href="{{accessLink}}">sign the document</a></p>
      </alert>
    </ng-container>
  </div>
</div>
